import { render, staticRenderFns } from "./createPedidos.vue?vue&type=template&id=fe32f1fe&scoped=true&"
import script from "./createPedidos.vue?vue&type=script&lang=js&"
export * from "./createPedidos.vue?vue&type=script&lang=js&"
import style0 from "./createPedidos.vue?vue&type=style&index=0&id=fe32f1fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe32f1fe",
  null
  
)

export default component.exports